import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconAngleProps extends SVGProps<any> {}
class SVGIconAngle extends Component<SVGIconAngleProps> {
  render() {
    const { width = 20, height = 20, fill, color, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-angle"
        width={width}
        height={height}
        viewBox={'0 0 10 20'}
        {...rest}
      >
        <path
          d="M9.53936 10C9.54031 10.5474 9.43588 11.0895 9.23203 11.5955C9.02818 12.1016 8.72892 12.5615 8.35135 12.949L1.70336 19.755C1.55014 19.9119 1.34232 20 1.12563 20C0.908938 20 0.701122 19.9119 0.547898 19.755C0.394674 19.5981 0.308594 19.3854 0.308594 19.1635C0.308594 18.9417 0.394674 18.7289 0.547898 18.5721L7.19588 11.7661C7.65302 11.2975 7.90979 10.6623 7.90979 10C7.90979 9.33772 7.65302 8.70253 7.19588 8.23394L0.547898 1.42792C0.394674 1.27106 0.308594 1.0583 0.308594 0.836458C0.308594 0.614616 0.394674 0.401859 0.547898 0.244993C0.701122 0.0881271 0.908938 0 1.12563 0C1.34232 0 1.55014 0.0881271 1.70336 0.244993L8.35135 7.05101C8.72892 7.43853 9.02818 7.89845 9.23203 8.40446C9.43588 8.91047 9.54031 9.45265 9.53936 10Z"
          fill="#11465d"
          fill-opacity="1"
        />
      </SVG>
    );
  }
}

class SVGIconAngleDouble extends Component<SVGIconAngleProps> {
  render() {
    const { width = 30, height = 28, fill, color, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-angle"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 ${width} ${height}`}
        {...rest}
      >
        <path
          d="M1.22973 16.9515L12.3367 28L15.2999 25.0485L4.19286 14L15.2999 2.95155L12.3283 0L1.22973 11.0485C0.44234 11.8313 9.53674e-06 12.893 9.53674e-06 14C9.53674e-06 15.107 0.44234 16.1687 1.22973 16.9515Z"
          fill={fill ?? color}
        />
        <path
          d="M14.4367 15.4758L27.0369 28L30 25.0485L18.893 14L30 2.95155L27.0285 0L14.4283 12.5242C14.0358 12.9168 13.8161 13.4482 13.8177 14.0017C13.8193 14.5552 14.0419 15.0854 14.4367 15.4758Z"
          fill={fill ?? color}
        />
      </SVG>
    );
  }
}

export default Object.assign(SVGIconAngle, {
  Double: SVGIconAngleDouble,
});
